<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index">
        @if (isBoxSubmenu(item)) {
        <!-- Box Submenu Item -->
        <li app-menuitem [item]="item" [index]="i" [root]="true" [boxSections]="getBoxSections(item)"></li>
        } @else {
        <!-- Regular Menu Item -->
        @if (!item.separator) {
        <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
        }
        }
        @if (item.separator) {
        <li class="menu-separator"></li>
        }
    </ng-container>
</ul>

<app-dialog [(visible)]="showLogoutConfirmDialog" [header]=" 'GENERIC.LOGOUT_CONFIRM_MESSAGE' | translate "
    [modal]="true" [style]="{ width: '450px' }">
    <div class="flex gap-3">
        <app-button [label]="'GENERIC.NO' | translate" variant="secondary" [fluid]="true" class="basis-1/2"
        (onClick)="showLogoutConfirmDialog = false" />
        <app-button [label]="'GENERIC.YES' | translate" variant="primary" [fluid]="true" class="basis-1/2"
            (onClick)="confirmLogout()" />
 
    </div>
</app-dialog>